import React, { createContext, useContext, useState } from 'react';

/**
 * AuthContext — exposes the signed-in user's identity and role to the app.
 * Seeded from localStorage (written by authService at login) so a page reload
 * keeps the user in place.
 */
const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user] = useState(() => ({
    uid: localStorage.getItem('uid'),
    uname: localStorage.getItem('uname') || '',
    fullName: localStorage.getItem('ufull_name') || '',
    role: localStorage.getItem('role') || 'doctor',
  }));

  return <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>;
};
